import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MANAGE_FEATURES } from '@/router/manageFeatures';

/**
 * Drives the admin dashboard: the management feature tiles and navigation to
 * each. Identity + lock/logout live in the app shell sidebar now, so this hook
 * only owns the tile list (the shared `MANAGE_FEATURES`) and the per-tile
 * navigation. Each tile routes to that feature's own page (a "coming soon" stub
 * until built) — the same routes the sidebar links to. Logic lives here so
 * `DashboardView` stays render-only.
 */
export const useDashboard = () => {
    const navigate = useNavigate();

    const openFeature = React.useCallback(
        (path: string) => navigate(path),
        [navigate],
    );

    return {
        features: MANAGE_FEATURES,
        openFeature,
    };
};

export type DashboardLogic = ReturnType<typeof useDashboard>;
